<template>
  <div class="card-report">
    <div class="u-title clearfix">
      <span class="l">
        <span class="card-name">{{ info.cardName }}</span>
        <el-popover
          placement="top"
          width="200"
          trigger="hover"
          :content="info.tip"
        >
          <span
            slot="reference"
            class="tip"
          >
            i
          </span>
        </el-popover>
      </span>
      <span class="r">
        <img
          class="card-logo"
          :src="info.cardLogo"
          alt="图标"
        >
      </span>
    </div>
    <div class="u-data">{{ info.data }}</div>
    <div class="u-ratio clearfix">
      <div class="week-ratio">
        <span class="r-txt">周同比</span>
        <span :class="dtc(info.last_week_ratio || 0).upordown" />
        <span :class="'r-per ' + dtc(info.last_week_ratio || 0).color">
          {{ dtc(info.last_week_ratio || 0).num }}
        </span>
      </div>
      <div class="day-ratio">
        <span class="r-txt">日环比</span>
        <span :class="dtc(info.yesterday_ratio || 0).upordown" />
        <span :class="'r-per ' + dtc(info.yesterday_ratio || 0).color">
          {{ dtc(info.yesterday_ratio || 0).num }}
        </span>
      </div>
    </div>
    <div class="u-line" />
    <div class="u-week-avg">
      <span class="txt">{{ info.bottomDesc }}</span>
      <span class="num">{{ info.last_week_average }}</span>
    </div>
  </div>
</template>

<script>
import $util from '@/common/js/util';

export default {
  name: 'Card',
  props: {
    info: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    dtc() {
      return (v) => ({
        num: v === 0 ? '--' : `${$util.numberCal.mul(v, 100)}%`,
        upordown: v === 0 ? '' : v > 0 ? 'up' : 'down',
        color: v === 0 ? '' : v > 0 ? 'red' : 'green',
      });
    },
  },
};
</script>

<style lang="less" scoped>
.card-report {
  display: inline-block;
  margin-bottom: 16px;
  margin-right: 48px;
  box-sizing: border-box;
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 22px;
  width: 300px;
  height: 188px;
  font-size: 14px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 2px;
  border: 1px solid rgba(220, 223, 230, 1);
  .u-title {
    .l {
      float: left;
      color: #909399;
      padding-top: 2px;
      .card-name {
        display: inline-block;
        vertical-align: middle;
        margin-right: 8px;
      }
      .tip {
        display: inline-block;
        vertical-align: middle;
        width: 14px;
        line-height: 14px;
        text-align: center;
        font-size: 9px;
        color: #909399;
        border: 1px solid #909399;
        border-radius: 9px;
      }
    }
    .r {
      float: right;
      width: 24px;
      height: 24px;
      text-align: center;
      .card-logo {
        width: 100%;
        height: 100%;
      }
    }
  }
  .u-data {
    margin-top: 10px;
    font-size: 30px;
    font-weight: bold;
    color: #2f9eff;
  }
  .u-ratio {
    margin-top: 20px;
    .week-ratio {
      float: left;
      width: 49%;
    }
    .day-ratio {
      float: right;
      width: 49%;
    }
    .r-txt {
      color: #606266;
    }
    .r-per {
      margin-left: 5px;
      &.red {
        color: #f5222c;
      }
      &.green {
        color: #52c418;
      }
    }
    .up {
      margin-left: 5px;
      margin-right: 6px;
      position: relative;
      &::after {
        position: absolute;
        top: 50%;
        transform: translate(0, -33%);
        content: ' ';
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 5px solid #f5222c;
      }
    }
    .down {
      margin-left: 5px;
      margin-right: 6px;
      position: relative;
      &::after {
        position: absolute;
        top: 50%;
        transform: translate(0, -33%);
        content: ' ';
        width: 0;
        height: 0;
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 5px solid #52c418;
      }
    }
  }
  .u-line {
    margin-top: 18px;
    width: 100%;
    height: 1px;
    background: rgba(232, 232, 232, 1);
  }
  .u-week-avg {
    margin-top: 8px;
    .txt {
      color: #606266;
    }
    .num {
      margin-left: 12px;
      color: #303133;
      font-family: HelveticaNeue;
    }
  }
}
.clearfix:after {
  visibility: hidden;
  display: block;
  font-size: 0;
  content: ' ';
  clear: both;
  height: 0;
}
</style>
